// extracted by mini-css-extract-plugin
module.exports = {"container":"Timer_container__3agub","text":"Timer_text__1jO36","timer":"Timer_timer__3iL2v","item":"Timer_item__23LFN","separator":"Timer_separator__1Aiuv"};